import {
    createBrowserRouter,
    RouterProvider,
    Outlet,
    createRoutesFromElements,
    Route,
    ScrollRestoration,
  } from "react-router-dom";
  import Header from "./Components/Header/Header";
  import Footer from "./Components/Footer/Footer";
  import Home from "../src/Pages/Home/Home";

  import { ToastContainer } from "react-toastify";
  import About from "./Pages/About/About";
  import Contact from "./Pages/Contact/Contact";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { useEffect, useState } from "react";
import Services from "./Pages/Services/Services";
import Projects from "./Pages/Projects/Projects";
import Partners from "./Pages/Partners/Partners";
import News from "./Pages/News/News";
import Careers from "./Pages/Careers/Careers";
import SubPodrat from "./Pages/SubPodrat/SubPodrat";
import ServicesDetail from "./Pages/ServicesDetail/ServicesDetail";
import ProjectDetail from "./Pages/ProjectsDetail/ProjectsDetail";
import NewsDetail from "./Pages/NewsDetail/NewsDetail";
import CareersResource from "./Pages/CareersResource/CareersResource";
import CareersLife from "./Pages/CareersLife/CareersLife";
import CareersProfessionals from "./Pages/CareersProfessionals/CareersProfessionals";
import CareersStarters from "./Pages/CareersStarters/CareersStarters";
import CareersJobs from "./Pages/CareersJobs/CareersJobs";
import CareersJobsDetail from "./Pages/CareersJobsDetail/CareersJobsDetail";
import SetemDetail from "./Pages/SetemDetail/SetemDetail";
import EthicsDetail from "./Pages/EthicsDetail/EthicsDetail";
  
  
  const Layout = () => {
    return (
      <div>
         <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        /> 
        {/* <AboveHeader/>
        <Header /> */}
        <ScrollRestoration />
        <Outlet />
        <Footer />
      </div>
    );
  };
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<Layout />}>
          {/* ==================== Header Navlink Start here =================== */}
          <Route path="/" element={ <Home />}></Route>

          <Route path="/about" element={ <About/>}></Route>

          <Route path="/setem/:id" element={ <SetemDetail/>}></Route> {/* + */}

          <Route path="/services" element={ <Services/>}></Route>
          <Route path="/services/:id" element={ <ServicesDetail/>}></Route>
          
          <Route path="/ethics/:id" element={ <EthicsDetail/>}></Route> {/* + */}

          <Route path="/projects" element={ <Projects/>}></Route>
          <Route path="/projects/:id" element={ <ProjectDetail/>}></Route>

          <Route path="/partners" element={ <Partners/>}></Route>

          <Route path="/news" element={ <News/>}></Route>
          <Route path="/news/:id" element={ <NewsDetail/>}></Route>

          <Route path="/careers" element={ <Careers/>}></Route>
          <Route path="/careers-resource" element={ <CareersResource/>}></Route>
          <Route path="/careers-life" element={ <CareersLife/>}></Route>
          <Route path="/careers-professionals" element={ <CareersProfessionals/>}></Route>
          <Route path="/careers-starters" element={ <CareersStarters/>}></Route>
          <Route path="/careers-jobs" element={ <CareersJobs/>}></Route>
          <Route path="/careers-jobs/:id" element={ <CareersJobsDetail/>}></Route> {/* + */}

          <Route path="/subpodrat" element={ <SubPodrat/>}></Route>
          <Route path="/contact" element={ <Contact/>}></Route>
        </Route> 
      </Route>
    )
  );
   
  function App() {
    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // 768px ve altı mobil olarak kabul ediliyor
      };
  
      handleResize(); // İlk render'da kontrol et
      window.addEventListener('resize', handleResize); // Ekran boyutu değişince tekrar kontrol et
  
      return () => {
        window.removeEventListener('resize', handleResize); // Temizlik
      };
    }, []);
  
    return (
      <div>
        <FloatingWhatsApp
          phoneNumber='+994553262709'
          accountName='Akond'
          statusMessage=''
          chatMessage='Salam, sizə necə kömək edə bilərik?'
          placeholder='Mesaj yazın...'
          avatar='./avatar.png'
          messageDelay='1'
        />
        
        <div className="font-firstFont">
        <RouterProvider router={router} />
      </div>
      </div>
    );
  }
  
  export default App;
  
  
  